/* eslint-disable max-len */
// deviceTemplateSearchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "template_id": '',
    "template_name": '',
    "manufacturer_name": '',
    "model": '',
    "template_creator":'',
    "created_day": '',
    "created_month": '',
    "created_year": '',
    "updated_day": '',
    "updated_month": '',
    "updated_year": '',
    "template_id_inverse": '',
    "template_name_inverse": '',
    "manufacturer_name_inverse": '',
    "model_inverse": '',
    "template_creator_inverse":'',
    "created_date_inverse": '',
    "updated_date_inverse": '',
    "match": false,
    "devicetempsearchApplied": false,

};

const deviceTemplateSearchSlice = createSlice({
    name: 'deviceTemplateSearch',
    initialState,
    reducers: {
        setDeviceTemplateSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetDeviceTemplateSearch(state) {
            return { ...initialState, devicetempsearchApplied: false }; // Reset state and flag
        },
        setDeviceTempSearchApplied(state) {
            state.devicetempsearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setDeviceTemplateSearch, resetDeviceTemplateSearch,setDeviceTempSearchApplied } = deviceTemplateSearchSlice.actions;

export default deviceTemplateSearchSlice.reducer;